//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"BooleanOperation",0,"GeometricUtilities.BooleanOperation",0],[1,"CounterboreDepth",0,"Expression",0],[1,"CounterboreDiameter",0,"Expression",0],[1,"CountersinkAngle",0,"Expression",0],[1,"CountersinkDiameter",0,"Expression",0],[1,"EndChamferAngle",0,"Expression",0],[0,"EndChamferEnabled",1,0],[1,"EndChamferOffset",0,"Expression",0],[0,"FitOption",1,0],[1,"HoleDiameter",0,"Expression",0],[0,"HoleForm",1,0],[1,"NeckChamferAngle",0,"Expression",0],[0,"NeckChamferEnabled",1,0],[1,"NeckChamferOffset",0,"Expression",0],[1,"ReliefDepth",0,"Expression",0],[0,"ReliefEnabled",1,0],[0,"ScrewSize",1,0],[0,"ScrewType",1,0],[1,"StartChamferAngle",0,"Expression",0],[0,"StartChamferEnabled",1,0],[1,"StartChamferOffset",0,"Expression",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.StartHoleData = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.StartHoleData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.StartHoleData.HoleForms = Object.freeze({
    "Simple" : "Simple", "Counterbored" : "Counterbored", "Countersink" : "Countersink"});

export default SPLM;